module.exports = __webpack_public_path__ + "media/images/dn-1-7fcaefe6.jpg";